<template>
  <nav class="level quick-stats">
    <div class="level-item has-text-centered">
      <div>
        <p class="heading">Pending / In&nbsp;Queue</p>
        <p class="title">{{ pending }} / {{ in_queue }}</p>
        <div class="actions">
          <b-button
            :icon-left="isBusy.pending ? 'loading mdi-spin' : 'restart'"
            :disabled="isBusy.pending"
            @click="requeue('pending')">
            Requeue pending
          </b-button>
        </div>
      </div>
    </div>
    <div class="level-item has-text-centered">
      <div>
        <p class="heading">Processing / Zombies</p>
        <p class="title">{{ processing }} / {{ zombies }}</p>
        <div class="actions">
          <b-button
            :icon-left="isBusy.zombies ? 'loading mdi-spin' : 'restart'"
            @click="requeue('zombies')">
            Requeue zombies
          </b-button>
        </div>
      </div>
    </div>
    <div class="level-item has-text-centered">
      <div>
        <p class="heading">Processed</p>
        <p class="title">{{ processed }}</p>
        <div class="actions"></div>
      </div>
    </div>
    <div class="level-item has-text-centered">
      <div>
        <p class="heading">Failed</p>
        <p class="title">{{ failed }}</p>
        <div class="actions"></div>
      </div>
    </div>
  </nav>
</template>

<script>
  import { requeueDocumentsRange } from '../api'

  export default {
    name: "QuickStatsSection",
    props: {
      pending: Number,
      processing: Number,
      processed: Number,
      failed: Number,
      zombies: Number,
      in_queue: Number,
      dateStart: Date,
      dateEnd: Date
    },
    data () {
      return {
        isBusy: {
          pending: false,
          zombies: false
        }
      }
    },
    methods: {
      async requeue(docsType) {
        this.isBusy[docsType] = true
        const rangeConfig = {
          date_start: this.dateStart,
          date_end: this.dateEnd,
          docs_type: docsType
        }
        try {
          await requeueDocumentsRange(rangeConfig)
          this.isBusy[docsType] = false
          this.$emit('requeued-docs', docsType)
          this.$buefy.toast.open(`Requeued ${docsType} documents`)
        } catch {
          this.isBusy[docsType] = false
          this.$buefy.toast.open({
            message: `Failed requeuing ${docsType} documents. An error occurred.`,
            type: 'is-danger'
          })
        }
      }
    }
  }
</script>

<style scoped>
  .actions {
    min-height: 36px;
    margin-top: 15px;
    margin-bottom: 35px;
  }
</style>
